module.exports = __webpack_public_path__ + "img/9_125.4ccf8128.png";